import { render, staticRenderFns } from "./PluginGoogleTagManagerTef.vue?vue&type=template&id=c9fe376a"
import script from "./PluginGoogleTagManagerTef.vue?vue&type=script&lang=js"
export * from "./PluginGoogleTagManagerTef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9fe376a')) {
      api.createRecord('c9fe376a', component.options)
    } else {
      api.reload('c9fe376a', component.options)
    }
    module.hot.accept("./PluginGoogleTagManagerTef.vue?vue&type=template&id=c9fe376a", function () {
      api.rerender('c9fe376a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginGoogleTagManagerTef.vue"
export default component.exports